import React from 'react';
import { Avatar, Chip } from '@mui/material';

export const FONT = 'Mulish, sans-serif';

export const authToken = () => {
  const raw = sessionStorage.getItem('token');
  return raw ? `Bearer ${raw}` : '';
};

export const STATUS = {
  active: { label: 'Active', bg: '#dcfce7', fg: '#166534' },
  inactive: { label: 'Inactive', bg: '#fee2e2', fg: '#991b1b' },
  verificationPending: { label: 'Pending', bg: '#fef3c7', fg: '#92400e' },
};

export const BUSINESS_TYPES = [
  { value: 'proprietorship', label: 'Proprietorship' },
  { value: 'partnership', label: 'Partnership' },
  { value: 'llp', label: 'LLP' },
  { value: 'private_limited', label: 'Private limited' },
  { value: 'public_limited', label: 'Public limited' },
  { value: 'other', label: 'Other' },
];

export const inr = (n) => `₹${Number(n || 0).toLocaleString('en-IN', { maximumFractionDigits: 0 })}`;
export const fmtDate = (d) => (d ? new Date(d).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' }) : '-');
export const fmtDateTime = (d) => (d ? new Date(d).toLocaleString('en-IN', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' }) : '-');

export const StatusChip = ({ status }) => {
  const s = STATUS[status] || { label: status || '-', bg: '#f1f5f9', fg: '#475569' };
  return <Chip size="small" label={s.label} sx={{ fontFamily: FONT, fontWeight: 700, height: 22, background: s.bg, color: s.fg }} />;
};

export const TypeChip = ({ type }) => (
  <Chip size="small" label={type === 'business' ? 'Business' : 'Customer'} sx={{ fontFamily: FONT, fontWeight: 700, height: 22, background: type === 'business' ? '#e0f2fe' : '#f1f5f9', color: type === 'business' ? '#0369a1' : '#475569' }} />
);

// name can be null for customers who signed up with only a mobile number
export const initials = (name) => (String(name || '').trim().split(/\s+/).filter(Boolean).slice(0, 2).map((p) => p[0]).join('') || '?').toUpperCase();

export const CustomerAvatar = ({ customer, size = 40 }) => (
  <Avatar src={customer?.image || undefined} alt={customer?.name} sx={{ width: size, height: size, bgcolor: '#ffd102', color: '#000', fontWeight: 800, fontSize: size * 0.38 }}>
    {initials(customer?.name)}
  </Avatar>
);

export const displayId = (c) => c?.customerId || `#${String(c?._id || '').slice(-6).toUpperCase()}`;

// light format checks (Indian GST / PAN)
export const GST_RX = /^\d{2}[A-Z]{5}\d{4}[A-Z][1-9A-Z]Z[0-9A-Z]$/;
export const PAN_RX = /^[A-Z]{5}\d{4}[A-Z]$/;
